query GetEditionStarters {
    editionStarters {
        id
        name
        thumbnailUrl
        createdTime
        status
        campaignId
        campaignName
        campaignDescription
        backgroundColor
    }
}
